import styled from 'styled-components'
import FilesIllustration from 'assets/images/icons/FileShareFilesIllustration.svg'
export const NoContentFiles = () => {
  return (
    <NoContentDiv>
      <div className="empty-illustration">
        <img src={FilesIllustration} />
        <p>No files yet</p>
        <span>Click “Upload File” to begin</span>
      </div>
    </NoContentDiv>
  )
}

const NoContentDiv = styled.div`
  .empty-illustration {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    p {
      margin-top: 1rem;
      ${({ theme }) => theme.typography.h4.medium};
    }
    span {
      ${({ theme }) => theme.typography.h6.normal};
    }
  }
`
